import React, { useEffect, useState } from "react";
import { bool, string } from "prop-types";
import { connect, useDispatch } from "react-redux";
import { goBack, push } from "connected-react-router";
import { Col } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import * as i18nUtils from "util/i18n";
import gaEventTracker, { events } from "util/gaEventTracker";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { selectors as modalselectors, actions as modalActions } from "reducers/modal";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";
import { ResponsiveHeader, MobileButtons } from "pages/_components/header";
import Help from "pages/onboarding/_components/Help";
import { isIOS } from "react-device-detect";
import { isMobileNative } from "../../../util/device";
import Stepper from "../_components/Stepper";
import { helpStepCUIT } from "./help";
// import Captcha from "pages/_components/fields/credentials/Captcha";

const FORM_ID = "onboarding.step.verifyCUIT";

const StepCUIT = ({ isMobile, business, exchangeToken, displayModal, onboardingWithEnrolledUser }) => {
    const dispatch = useDispatch();
    const [validateError, setvalidateError] = useState(false);

    const [confirmStep, setConfirmStep] = useState("");
    const [razonSocial, setRazonSocial] = useState("");

    const [title, settitle] = useState("");

    const [error, setError] = useState(
        "Por el momento no pudimos validar tu empresa. Por favor, verificá si el CUIT ingresado es correcto.",
    );
    const [error2, setError2] = useState("");
    const [image, setimage] = useState("");
    const [isValidating, setIsValidating] = useState(false);
    const [formRef, setFormRef] = useState();

    const [pageId, setPageId] = useState("StepCUIT");

    useEffect(() => {
        if (onboardingWithEnrolledUser) {
            setPageId("StepCUITEnrolledUser");
        }
    }, [onboardingWithEnrolledUser]);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                () => {
                    gaEventTracker.triggerEvent(events.registry2);
                },
                () => {
                    setvalidateError(true);
                    settitle("Permiso de geolocalización rechazado");
                    setimage("figma/illustrations/onboarding13.svg");
                    setError("No podemos continuar con el proceso de onboarding.");
                    setError2("Se necesita aceptar permisos para continuar con la navegación.");
                    // dispatch(modalActions.modalShow());
                    // setError(
                    //     i18nUtils.get(
                    //         "permissions.user.geolocation.required",
                    //         "Sin otorgar estos permisos, no podrás continuar",
                    //     ),
                    // );
                },
            );
        }
    }, []);

    useEffect(() => {
        let data = business?.data?.business?.activities ?? [];
        data = data?.filter((x) => x.activityCodeStatus === "P") ?? [];
        if (isValidating && business?.status === "LIMIT_ERROR") {
            setIsValidating(false);
            dispatch(modalActions.modalShow());
        } else if (isValidating && business?.status === "CUIT_IN_BIBANK") {
            setIsValidating(false);
            setError(
                business?.message ||
                    i18nUtils.get(
                        "onboarding.step.verifyCUIT.cuit.alreadyExits",
                        "Ya eres cliente en BiBank, comunícate con tu asesor asignado",
                    ),
            );
            dispatch(modalActions.modalShow());
        } else if (isValidating && business?.status === "CUIT_NOT_IN_AFIP") {
            setIsValidating(false);
            setvalidateError(true);
            settitle("Disculpe");
            setimage("figma/illustrations/onboarding13.svg");
            setError("Error de conexión, no es posible validar identidad. Por favor intente más tarde.");
            setError2("");
            // setError(
            //     i18nUtils.get(
            //         "onboarding.step.verifyCUIT.errors.cuitNotInAfip",
            //         "En tu constancia de ARCA vemos que tu empresa no está registrada en ARCA",
            //     ),
            // );
            // dispatch(modalActions.modalShow());
        } else if (isValidating && business?.status === "CUIT_NOT_REGISTERED_RESPONSIBLE") {
            setIsValidating(false);
            // dispatch(modalActions.modalShow());
            // setError(
            //     i18nUtils.get(
            //         "onboarding.step.verifyCUIT.errors.cuitNotRegisteredResponsible",
            //         "Con este CUIT no podrás continuar",
            //     ),
            // );
            setvalidateError(true);
            settitle("Ingreso de CUIT inválido");
            setimage("figma/illustrations/onboarding13.svg");
            setError(
                "Por el momento no pudimos validar tu empresa. Por favor, verificá si el CUIT ingresado es correcto.",
            );
            setError2("");
        } else if (isValidating && business?.status === "CUIT_VALID") {
            if (data.length > 0) {
                setIsValidating(false);
                setError(
                    i18nUtils.get(
                        "onboarding.step.verifyCUIT.errors.cuitInBibank",
                        "Lo sentimos, en estos momentos no se puede continuar con el proceso de onboarding",
                    ),
                );
                dispatch(modalActions.modalShow());
                return;
            }
            setIsValidating(false);
            setRazonSocial(business.name);
            setConfirmStep("1");
        } else if (isValidating && business?.status === "VU_NEW_OPERATION_ERROR") {
            setIsValidating(false);
            setError(
                i18nUtils.get(
                    "onboarding.vu.new.operation.error",
                    "Error de conexión, no es posible validar identidad. Por favor intente nuevamente.",
                ),
            );
            dispatch(modalActions.modalShow());
        }
    }, [isValidating, formRef, business]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const validateCUIT = (values) => {
        if (values) {
            if (values.includes(",") || values.includes(".") || values.includes("-")) {
                return false;
            }
            const cuit = values.replace(new RegExp("[^\\d.,]", "g"), "");
            if (cuit.length !== 11) {
                return false;
            }
            const cuitArray = cuit.split("");
            const serie = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
            let aux = 0;
            for (let i = 0; i < 10; i++) {
                aux += parseInt(cuitArray[i], 10) * serie[i];
            }
            aux = 11 - (aux % 11);
            if (aux === 11) {
                aux = 0;
            }
            if (!Object.is(parseInt(cuitArray[10], 10), aux)) {
                return false;
            }
        }
        return true;
    };

    const formikProps = {
        validateOnChange: true,
        validateOnBlur: true,
        initialValues: {
            cuit: "",
            razonSocial: "",
            // captcha: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                cuit: Yup.string()
                    .required(i18nUtils.get("global.error.required"))
                    .test("cuit", i18nUtils.get("onboarding.step.verifyCUIT.cuit.error.invalidFormat"), (value) =>
                        validateCUIT(value),
                    ),
                // captcha: !isMobile
                //     ? Yup.string().required(i18nUtils.get("login.step2.captcha.required"))
                //     : Yup.string(),
            }),
        onSubmit: ({ ...data }, formikBag) => {
            setIsValidating(true);
            if (!confirmStep && formikBag) {
                dispatch(onboardingActions.verifyCUIT(data.cuit, exchangeToken));
            } else if (confirmStep === "1") {
                dispatch(push("/onboarding/stepEmail"));
            }
        },
    };

    const onChangeCUIT = () => {
        setRazonSocial("");
        setConfirmStep("");
    };

    const handleClickButtonClose = () => {
        dispatch(modalActions.modalClose());
        // dispatch(push("/"));
    };

    const handleModal = () => (
        <>
            {isMobile && (
                <Head
                    title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onBack={isMobile && handleClickButtonClose}
                    hideNavbarInMobile
                />
            )}
            <MainContainer>
                {!isMobile && (
                    <Container>
                        <Col xs={12} md={8} mdOffset={2}>
                            <Head
                                title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                                onBack={isMobile && handleClickButtonClose}
                            />
                        </Col>
                    </Container>
                )}
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText text={i18nUtils.get("", "Ingreso de CUIT inválido")} />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image src="figma/illustrations/onboarding13.svg" className="svg-image logo" />
                </div>
                {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                <div className="box box-border-soft">
                    {" "}
                    <CustomText text={i18nUtils.get("", error)} />
                    {error2 !== "" ? (
                        <>
                            <br />
                            <br />
                            <CustomText text={i18nUtils.get("", error2)} />
                        </>
                    ) : null}
                </div>

                <div className="form-actions">
                    <Button
                        bsStyle="primary"
                        label="onboarding.stepCuit.retry"
                        loading={false}
                        onClick={handleClickButtonClose}
                    />
                </div>
            </MainContainer>
        </>
    );
    if (validateError) {
        return (
            <>
                {isMobile && (
                    <ResponsiveHeader
                        ticket
                        id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onClickBack={isMobile && onHeaderBack}>
                        <MobileButtons
                            image={isIOS ? "images/figma/icon/help-white.svg" : "images/figma/icon/help.svg"}>
                            <Help list={helpStepCUIT} />
                        </MobileButtons>
                    </ResponsiveHeader>
                )}
                <MainContainer>
                    {!isMobile && (
                        <Container>
                            <Col xs={12} md={8} mdOffset={2}>
                                <Head
                                    title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                                    onBack={isMobile && onHeaderBack}
                                />
                            </Col>
                        </Container>
                    )}
                    <Col xs={12} md={8} mdOffset={2}>
                        <h1 className="text-center">
                            <CustomText text={i18nUtils.get("", title)} />
                        </h1>
                    </Col>
                    <div className="illustration text-center">
                        <Image src={image} className="svg-image logo" />
                    </div>
                    {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                    <div className="box box-border-soft">
                        {" "}
                        <CustomText text={i18nUtils.get("", error)} />
                        {error2 !== "" ? (
                            <>
                                <br />
                                <br />
                                <CustomText text={i18nUtils.get("", error2)} />
                            </>
                        ) : null}
                    </div>

                    <div className="form-actions">
                        <Button
                            bsStyle="primary"
                            label="onboarding.stepCuit.retry"
                            loading={false}
                            onClick={() => {
                                setvalidateError(false);
                            }}
                        />
                    </div>
                </MainContainer>
            </>
        );
    }
    return !displayModal ? (
        <>
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                    showCenterContent>
                    <MobileButtons image={isIOS ? "images/figma/icon/help-white.svg" : "images/figma/icon/help.svg"}>
                        <Help list={helpStepCUIT} />
                    </MobileButtons>
                </ResponsiveHeader>
            )}
            <MainContainer>
                {!isMobile && (
                    <Head
                        title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onBack={isMobile && onHeaderBack}
                    />
                )}
                <Stepper isMobile={isMobile} page={pageId} />
                <h1 className="text-center" style={{ textAlign: "left" }}>
                    <CustomText text={i18nUtils.get("", "Ingresá el CUIT de tu empresa")} />
                </h1>
                <CustomText
                    text={i18nUtils.get(
                        "",
                        "Identificá la empresa que querés adherir a BiBank (Validaremos con ARCA).",
                    )}
                />
                <Formik {...formikProps} ref={(el) => setFormRef(el)}>
                    {(allFormik) => (
                        <Form className="above-the-fold">
                            <Field
                                autoComplete="off"
                                idForm={FORM_ID}
                                component={TextField}
                                maxLength={50}
                                name="cuit"
                                placeholder="Ej: 30123456781"
                                labelTextDefault="CUIT"
                                handleOnChange={onChangeCUIT}
                                autoFocus={!isMobile}
                                showNumericKeyboard={isMobileNative}
                            />
                            {/* {!isMobile && <Field idForm={FORM_ID} name="captcha" component={Captcha} />} */}

                            {razonSocial && allFormik.isValid && allFormik.dirty && (
                                <Field
                                    autoComplete="off"
                                    idForm={FORM_ID}
                                    component={TextField}
                                    value={razonSocial}
                                    hidePlaceholder
                                    disabled
                                    labelTextDefault="Denominación social"
                                    isIos={isIOS}
                                />
                            )}
                            {/* <div className="container--alert" role="alert">
                                <div className="alert alert-info">
                                    <CustomData
                                        icon="information_fill.svg"
                                        titleText="Validaremos tu empresa con la ARCA."
                                        keepSpaceIfNoValue={false}
                                    />
                                </div>
                            </div> */}
                            <div className="form-actions">
                                <Button
                                    bsStyle="primary"
                                    label="global.continue"
                                    type="submit"
                                    block
                                    disabled={!(allFormik.isValid && allFormik.dirty)}
                                    loading={allFormik.isSubmitting && isValidating}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    ) : (
        handleModal()
    );
};

StepCUIT.propTypes = {
    isDesktop: bool.isRequired,
    isMobile: bool.isRequired,
    exchangeToken: string.isRequired,
    business: string,
    displayModal: bool,
    onboardingWithEnrolledUser: bool.isRequired,
};

StepCUIT.defaultProps = {
    business: "",
    displayModal: false,
};

const mapStateToProps = (state) => ({
    business: onboardingSelectors.getBusiness(state),
    displayModal: modalselectors.getDisplayModal(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepCUIT);
